// extracted by mini-css-extract-plugin
export default {"container":"f1-z","heading":"g1-z","links":"h1-z","copy":"i1-z","subCopy":"j1-z","linksLeft":"k1-z","linksCenter":"l1-z","linksRight":"m1-z","link":"n1-z","onlyLink":"o1-z"};